var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticStyle:{"position":"relative"}},[(!_vm.disableCartFloatingButton)?_c('CartFloatingButton'):_vm._e(),_c('v-fade-transition',{attrs:{"hide-on-leave":""}},[_c('router-view')],1),_c('WhatsappButton')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }